import React from "react";
import cn from "classnames";

import { useIntl } from "react-intl";

import NotFoundContent from "../../components/NotFoundContent";
import Seo from "../../../common/helpers/seo";

import { StyledNotFound } from "./styles";
import messages from "./messages";

const NotFound = () => {
    const { formatMessage } = useIntl();
    return (
        <StyledNotFound marginTop={50} className={cn("spring--shadow", "spring--padding")}>
            <Seo title={formatMessage(messages.title)} />
            <NotFoundContent />
        </StyledNotFound>
    );
}

export default NotFound;
